import { Directive, HostListener, ElementRef, Input, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Directive({
  selector: '[appInputRegex]'
})
export class InputRegexDirective implements OnInit, OnChanges {
  @Input() pattern?: string | RegExp;
  @Input() formControl?: UntypedFormControl;
  private regex: RegExp;

  constructor(
  ) {
    this.regex = this.pattern ? RegExp(this.pattern) : null;
  }

  ngOnInit() {
    this.regex = new RegExp(this.pattern);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.pattern) {
      this.regex = this.pattern ? RegExp(this.pattern) : this.regex;
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): any {
    let valTobeTested = '';
    
    if(this.formControl?.value) {
      valTobeTested = this.formControl.value + e.key;
    } else {
      valTobeTested = e.key;
    }

    if (!this.regex.test(valTobeTested) && e.key != 'Backspace') {
      e.preventDefault();
    }
  }
}
